import script from "./Principal.vue?vue&type=script&setup=true&lang=js"
export * from "./Principal.vue?vue&type=script&setup=true&lang=js"

import "./Principal.vue?vue&type=style&index=0&id=2d0c7e57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0c7e57"]])

export default __exports__